export const CUSTOMIZATION_MODAL_TEST_ID = 'document-customization-modal'
